import { forwardRef } from 'react';
import { MenuItem, Paper, TextField } from '@mui/material';
import { FpReference } from './FpCriteria';

const LikelihoodMenuPaper = forwardRef(function LikelihoodMenuPaper({ children, fp, selectedLevel, ...props }, ref) {
  return <Paper {...props} ref={ref}>
    <div className="fp-likelihood-menu">
      <div className="fp-likelihood-options">{children}</div>
      <aside aria-label="가능성 판단 참고 기준"><FpReference fp={fp} selectedLevel={selectedLevel} /></aside>
    </div>
  </Paper>;
});

export function LikelihoodSelect({ criteria, ...props }) {
  const selected = criteria.frequencies.find(row => Number(row.frequency_id) === Number(props.value));
  return <TextField {...props} select fullWidth size="small" label="가능성"
    SelectProps={{ MenuProps: { PaperProps: { component: LikelihoodMenuPaper, fp: criteria.fp,
      selectedLevel: selected?.frequency_level, sx: { width: 800, maxWidth: 'calc(100vw - 32px)' } } } }}>
    {criteria.frequencies.map(row => <MenuItem key={row.frequency_id} value={row.frequency_id}
      onClick={event => event.stopPropagation()} sx={{ whiteSpace: 'normal', overflowWrap: 'anywhere', minHeight: 44 }}>
      {row.frequency_level} - {row.frequency_description}
    </MenuItem>)}
  </TextField>;
}
